// extracted by mini-css-extract-plugin
export default {"couponsWrapper":"MobileCoupon_couponsWrapper","disabled":"MobileCoupon_disabled","item":"MobileCoupon_item","active":"MobileCoupon_active","add":"MobileCoupon_add"};